@if (compact) {
  <button
    type="button"
    class="app-sidebar__scrim"
    [class.is-visible]="open"
    aria-label="Close navigation"
    (click)="closeCompactSidebar()"
  ></button>
}

<aside
  class="app-sidebar"
  [class.is-hidden]="hidden && !compact"
  [class.is-collapsed]="collapsed && !compact"
  [class.is-compact]="compact"
  [class.is-open]="open"
  (pointerenter)="requestHoverExpansion()"
  (pointerleave)="requestHoverCollapse()"
>
  <div class="app-sidebar__panel">
    <nav class="app-sidebar__nav">
      @for (item of visibleItems; track item.route) {
        <div class="app-sidebar__group">
          <button
            type="button"
            class="app-sidebar__item"
            [class.is-active]="isItemOrChildActive(item)"
            [title]="item.label"
            (click)="handleRootItemClick(item)"
          >
            <ion-icon [name]="item.icon"></ion-icon>
            @if (labelsVisible) {
              <span class="app-sidebar__label">{{ item.label }}</span>
              @if (item.children?.length) {
                <ion-icon
                  class="app-sidebar__caret"
                  [class.is-expanded]="isGroupExpanded(item)"
                  name="chevron-down-outline"
                ></ion-icon>
              }
            }
          </button>

          @if (isGroupExpanded(item)) {
            <div class="app-sidebar__children">
              @for (child of item.children; track child.route) {
                <a
                  class="app-sidebar__child"
                  [class.is-active]="isItemActive(child)"
                  [routerLink]="child.route"
                  [title]="child.label"
                  (click)="handleChildNavigate()"
                >
                  <span class="app-sidebar__child-marker"></span>
                  <span>{{ child.label }}</span>
                </a>
              }
            </div>
          }
        </div>
      }
    </nav>

    @if (!compact) {
      <div class="app-sidebar__footer">
        <button
          type="button"
          class="app-sidebar__pin-toggle"
          [title]="pinButtonLabel"
          (click)="togglePinMode()"
        >
          <ion-icon [name]="pinButtonIcon"></ion-icon>
          @if (labelsVisible) {
            <span>{{ pinButtonLabel }}</span>
          }
        </button>
      </div>
    }
  </div>
</aside>
